<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col-md-12">
        <h3 class="display-5 mx-3">My Projects</h3>
      </div>
    </div>
    <div class="row px-3" v-for="(item,index) in projectlist.projects" :key="index">
      <div class="col-md-3 my-2">
        <img :src="item.img" style="width:100%;" class="p-0" />
      </div>
      <div class="col-md-8">
        <h4 class="mt-3">{{item.name}}</h4>
        <p>{{item.technology}}</p>
        <p>{{item.about}}</p>
        <a :href="item.url" target="blank" class="btn btn-success">Explore</a>
      </div>

      <div class="col-md-12"></div>
    </div>
  </div>
</template>

<script>
import projectlist from "@/assets/data/projects.json";
export default {
  name: "projects",
  data: () => ({
    projectlist
  })
};
</script>